import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import type GridConfiguration from '../types/GridConfiguration'

export const TrackerConfiguration: GridConfiguration = {
  columns: [
    {
      field: 'code',
      header: 'Retailer Code',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'name',
      header: 'Retailer Name',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'total_turnover',
      header: 'Amount',
      type: 'currency',
    },
    {
      field: 'contribution',
      header: 'Contribution To Group Performance',
      type: 'percent',
    },
  ],
  settings: [
    { name: 'showDownloadDocument', value: false },
    { name: 'showDownloadSpreadsheet', value: true },
    { name: 'showMonthFilter', value: false },
    { name: 'showYearFilter', value: true },
    { name: 'showColumnSelect', value: true },
  ],
}
